import React from 'react';
import { Text, TextMessage } from 'components/tt-forms/common';

class TrinhLanhDaoKTDXView extends React.Component {

  render() {

    return (
      <div className="items-form mb5">
        <div className="row pl10 pr10 mb10">
          <Text
            className="col-input"
            label="Ban lãnh đạo:"
            value={this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo ?
              this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen : ''} />
        </div>
        <div className="row pl10 pr10">
          <TextMessage
            className="col-12"
            value={this.props.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo.yKienXuLy ? this.props.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo.yKienXuLy : ''}
            label='Nội dung:' />
        </div>
      </div>
    )
  }
}

export default TrinhLanhDaoKTDXView;


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-kiem-tra-de-xuat/chuyen-vien-nhap-lieu/TrinhLanhDaoKTDXView.jsx